<template>
<div class="plans-section">
  <expandable-summary-row text-style="medium"
                          :with-shadow=false
                          :is-expandable="true"
                          :initially-expanded="initiallyOpened"
                          @expanded="onExpand">
    <template v-slot:header>
      <div class="text-container">
        <span class="text">פירוט תוכניות גדולות</span>
      </div>
    </template>
    <template v-slot:content>
      <plan-section v-for="plan in enrichedPlans" :plan="plan" :key="plan._id"  @edit-plan-click="() => openEditPage(plan)"/>
      <div class="total-summary">
        <div class="total-line">
          <plan-summary-line name="סה״כ" :amount="totalMonthlyTarget" />
        </div>
        <plan-status-note class="note" :text="noteText" :is-on-track="isOnPlansTrack" is-bold />
        <separator />
        <riseup-button :action="goToPlanAheadPage"
                       subtitle="לעריכת התוכניות הגדולות  >"
                       variant="flat-black"
                       size="slim"
                       :bold="true"
                       class="edit-plans-button" />

      </div>
    </template>
  </expandable-summary-row>
</div>
</template>

<script>
import Segment from '@/Segment';
import * as _ from 'lodash';
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import moneyUtils from '@/utils/money';
import router from '@/router';
import BaseUi from 'base-ui';
import PlanStatusNote from '@/pages/responsive-pages/authenticated/navigation-pages/plan-ahead/PlanStatusNote';
import PlanEditPage from '@/pages/responsive-pages/authenticated/navigation-pages/plan-ahead/PlanEditPage';
import PlanSection from './PlanSection';
import PlanSummaryLine from './PlanSummaryLine';
import ExpandableSummaryRow
  from '../../../cashflow-app/cashflow-view/generic-components/cashflow-types/cashflow-types-base/ExpandableSummaryRow';

export default {
  name: 'PlansSection',
  components: {
    PlanStatusNote,
    PlanSection,
    ExpandableSummaryRow,
    PlanSummaryLine,
    RiseupButton: BaseUi.RiseupButton,
    Separator: BaseUi.Separator,
  },
  created() {
    Segment.trackUserGot('PlanAhead_Section_Shown', { isOnPlansTrack: this.isOnPlansTrack });
    this.initiallyOpened = this.showPlansInSection;
    this.setShowPlansInSection(false);
  },
  data() {
    return {
      checkIconColor: BaseUi.Colors.riseupGreen,
      errorIconColor: BaseUi.Colors.riseupDangerRed,
      initiallyOpened: false,
    };
  },
  props: {
    plans: {
      type: Array,
      require: true,
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    ...mapMutations('planAhead', ['setShowPlansInSection']),
    openEditPage(plan) {
      Segment.trackUserInteraction('PlanAhead_Section_GoToPlanPage');
      this.openModal({
        component: PlanEditPage,
        props: {
          plan,
        },
        popupAlignment: 'full-screen',
      });
    },
    goToPlanAheadPage() {
      Segment.trackUserInteraction('PlanAhead_Section_GoToPlansDashboard');
      router.push({ path: '/plan-ahead' });
    },
    onExpand() {
      Segment.trackUserInteraction('PlanAhead_Section_Expanded');
    },
  },
  computed: {
    ...mapGetters('cashflowView', ['riseupGoal']),
    ...mapState('planAhead', ['showPlansInSection']),
    totalMonthlyTarget() {
      return _.sumBy(this.plans, plan => plan.monthlyTarget);
    },
    isOnPlansTrack() {
      return this.riseupGoal >= this.totalMonthlyTarget;
    },
    onTrackPlansGap() {
      return moneyUtils.formatAmountWithFraction(this.totalMonthlyTarget - this.riseupGoal, 0);
    },
    noteText() {
      return this.isOnPlansTrack
        ? 'נראה שהכל בכיוון הנכון'
        : `נראה שחסרים ${this.onTrackPlansGap} ₪ כדי להגיע לסכום החודשי`;
    },
    enrichedPlans() {
      const reducedPlans = this.plans.reduce((acc, plan) => {
        const isOnTrack = acc.remaining - plan.monthlyTarget >= 0;
        const notOnTrackDiff = isOnTrack ? 0 : plan.monthlyTarget - acc.remaining;
        const amountDiff = isOnTrack ? plan.monthlyTarget : acc.remaining;
        return {
          plans: acc.plans.concat({ ...plan, isOnTrack, notOnTrackDiff }),
          remaining: acc.remaining - amountDiff,
        };
      }, { plans: [], remaining: this.riseupGoal });
      return reducedPlans.plans;
    },
  },
  watch: {
    async isOnPlansTrack(newValue) {
      Segment.trackUserGot('PlanAhead_Section_OnTrackChanged', { isOnPlansTrack: this.isOnPlansTrack });
    },
  },
};
</script>

<style scoped lang="scss">
.plans-section {
  font-size: 14px;

  .text-container {
    display: flex;
    align-items: center;
    font-weight: bold;
    height: 50px;
    padding-right: 7px;

    .text {
      width: 100%;
    }
  }
  .total-summary {
    .total-line {
      font-weight: bold;
      font-size: 18px;
    }

    .note {
      padding-right: 30px;
      margin-bottom: 15px;
    }
  }
}
</style>
